module.exports = __webpack_public_path__ + "static/scale-model-of-fielder-house-museum-in-arlington-texas-f58a8f90e14897254b7d873845ea40aa.png";